export const environment = {
  /*... Variables for Session Timeout ...*/

  popUpDuration: 300, /**Duration for which the popup should be shown in seconds - 5 minutes**/
  maxInactiveIntervalTime: 1000 * 600, /**milliseconds - 10 minutes*/
  isLoggedIn: true, /**indicates a logged in session is on**/
  timeOutHandler: 0, /**The setTimeout function handler**/
  countdownHandler: 0, /**The handler for showing the timeout countdown**/
  showTimeoutWarning: false, /**app.component.ts looks for this every second. If set, the timeout warning is shown with
  countdown from popupDuration value down to 0**/
  lastApiHitTimestamp: 0,    /** The timestamp at which the last API hit was made. This does not include keepAlive requests
  to keep AHCT Session active**/
  lastKeepAliveTimestamp: 0,  /** The timestamp at which the last keep alive was sent **/
  keepAliveWindowMs: 120000,  /** Every 120 seconds, if inactivity has not happened, do a keep alive request to /AHCT/pingSession **/


  isApiHit: false,
  production: true,
  showTestData: false,
  sessionTimeOutInterval: 0,
  IsPopupShowed: false,
  pageLoadTimestamp: 0,
  alerts: [],
  infoMessages: [],
  warnMessages: [],
  envName: 'production',
  idleSet: 30,
  // Recovered 2026-09-19 from the LIVE production bundle
  // (main.7063a40769ead4e2b50d.js). The previous values pointed at d1-slp-wp,
  // the DEV portal - a production build with those would have authenticated
  // against dev from the production origin.
  logoutUrl: 'https://www.supremelifeplatform.com/logout/',
  walletCodeJM:'251122',
  walletCodeGY:'928025',
  idleTimeout: 30,
  addForgerockHeaders: true,
  // Altenar PRODUCTION, not -stage, and justbetjaretail rather than
  // justbetdevretail. Both differ from staging; this pair is the one
  // genuinely production-specific thing in this file.
  sportsBettingUrl: 'https://sb2integration-altenar2.biahosted.com/api/Integration/justbetjaretail',
  sportsBettingUrlV2: 'https://sb2wsdk-altenar2.biahosted.com/altenarWSDK.js',
  // Altenar WSDK integration names (recovered from the live prod bundle main.7063a40769ead4e2b50d.js; GY value unconfirmed)
  altenarIntegrationJM: 'justbetjaretail',
  altenarIntegrationGY: 'justbetjaretail',
  baseAuthUrl: '',
  baseApiUrl: 'https://www.supremelifeplatform.com/wp-json/',
  // The live production bundle defines NO kiosk URL. Kept empty rather than
  // carrying the d2 dev host forward - an unverified endpoint that only some
  // screens call is exactly the kind of thing that passes a deployment and
  // fails in front of a cashier. Set it when the production kiosk host is
  // confirmed.
  kioskbaseApiUrl: '',
  baseJSPMLicenseKeyUrl: 'https://www.supremelifeplatform.com/jspm/index.php',
  baseWebRedirUrl: '',
  version: '0.0.6',
  gaKey: 'UA-196038757-1'
};
